export default {
  SMS: 0,
  EMAIL: 1,
  TWITTER: 2,
  FACEBOOK: 3,
  GPLUS: 4,
  MIXIT: 5,
  WE_CHAT: 6,
  WEBHOOK: 7,
  USSD: 8,
  WHATSAPP: 9,
  INSTAGRAM: 10,
  CELLFIND: 11,
  TELEGRAM: 12,
  TIKTOK: 22,
};



// WEBPACK FOOTER //
// ./src/store/modules/channel/channelTypes.js